import { AuthEnums } from "models/enums";
import { ServiceConstants } from "utils/constants";
import useAPIClientHelper from "./useAPIClientHelper";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

function useEmployeeService() {
  const { apiClientInstance } = useAPIClientHelper();

  const get = () => {
    return apiClientInstance(AuthEnums.AuthType.Company).EmployeesClient.Get(ServiceConstants.DefaultFilter);
  };

  const getEmployee = (id: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .EmployeesClient.GetByIdAsync(id)
      .then((res) => res.data);
  };

  const createEmployee = (employee: WintSuperkollAPIModel.EmployeePost) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    })
      .EmployeesClient.Create(employee)
      .then((res) => res.data);
  };

  const updateEmployee = (id: number, employee: WintSuperkollAPIModel.EmployeePut) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    })
      .EmployeesClient.Update(id, employee)
      .then((res) => res.data);
  };

  const activateSalary = (employeeId: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    }).SettingsClient.ActivateSalary(employeeId);
  };

  const deactivateSalary = (employeeId: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    }).SettingsClient.InactivateSalary(employeeId);
  };

  const removeEmployee = (employeeId: number, extraData: WintSuperkollAPIModel.EmployeeDeleteExtraData) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    }).EmployeesClient.Delete(employeeId, extraData);
  };

  return {
    get,
    getEmployee,
    createEmployee,
    updateEmployee,
    activateSalary,
    deactivateSalary,
    removeEmployee,
  };
}

export default useEmployeeService;
